import Handler from "../Handler";

class SendThrowableAckHandler extends Handler {
  execute(data) {
    let receivedData = JSON.parse(data);
    this.service.processThrowablesOnTable(receivedData);
  }
}

export default SendThrowableAckHandler;
// sendThrowableA#{“fromPlayerName”:””,”toPlayerName”:””,”tableId”:””,”throwableId”:””, ”statusCode”:200}
